import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import BankAccountsView from 'components/composed/views/BankAccountsView';

const StyledContainer = styled.div`
  @media ${theme.devices.tablet} {
  }
`;

const ConfigureSection = () => {
  return (
    <StyledContainer>
      <BankAccountsView />
    </StyledContainer>
  );
};

export default ConfigureSection;
